import { render, staticRenderFns } from "./SummaryValue.vue?vue&type=template&id=3a70b7b4&"
import script from "./SummaryValue.vue?vue&type=script&lang=js&"
export * from "./SummaryValue.vue?vue&type=script&lang=js&"
import style0 from "./SummaryValue.vue?vue&type=style&index=0&id=3a70b7b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports